<template>
  <div id="barCodeSettings">
    <div class="feature" v-if="barCodeSettings">
      <span class="feature-name">{{$t('barcodes.activate')}}</span>
      <select v-model="barCodeSettings.active">
        <option :value="true">{{$t('yes')}}</option>
        <option :value="false">{{$t('no')}}</option>
      </select>
    </div>
    <template v-if="barCodeSettings && barCodeSettings.active">
      <span class="group subtitle-2 separator">{{$t('barcodes.manage')}}</span>
      <div class="group">
        <label><span>{{$t('barcodes.total_length')}}</span><Tooltip :text="$t('barcodes.total_length_tip')"></Tooltip></label>
        <input type="number" v-model="barCodeSettings.totalLenght" min="0" max="20">
      </div>
      <!--    <div class="group">-->
      <!--      <input type="checkbox" id="chk_zero" v-model="barCodeSettings.ignoreLeadingZero">-->
      <!--      <label for="chk_zero"><span style="padding-right: 10px">{{$t('barcodes.ignore_leading_zero')}}</span><Tooltip :text="$t('barcodes.ignore_leading_zero_tip')"></Tooltip></label>-->
      <!--    </div>-->
      <div class="barcode-settings__price-setting">
        <div class="price-setting__values">
          <div class="group price-setting__start-index">
            <label><span>{{$t('barcodes.start_index')}}</span><Tooltip :text="$t('barcodes.start_index_tip')"></Tooltip></label>
            <input type="number" min="0" :max="maxPriceIndex" :value="priceStartIndex"
                   @input="event => barCodeSettings.priceStartIndex = parseInt(event.target.value) -1">
          </div>
          <div class="group price-setting__length">
            <label><span>{{$t('barcodes.price_length')}}</span><Tooltip :text="$t('barcodes.price_length_tip')"></Tooltip></label>
            <input type="number" v-model="barCodeSettings.priceLength" min="2" max="4">
          </div>
        </div>
        <div class="price-setting__display">
          <label><span>{{$t('barcodes.price_preview')}}</span><Tooltip :text="$t('barcodes.price_preview_tip')"></Tooltip></label>
          <div class="barcode__code">
            <div v-for="(index,i) in indexes" :key="i" class="digit" :class="{highlighted: index, start: (i + 1) == priceStartIndex, end: ((i + 1) == priceEndIndex && priceLengthValidation)}">
              x
            </div>
          </div>
        </div>
      </div>
    </template>

  </div>
  
</template>

<script>
  import Tooltip from "@/components/tools/Tooltip";

  export default {

    name: "BarCodeSettings",

    components: { Tooltip },

    data() {
      return {
        maximumCodeBarLength: 20,
      }
    },

    props: {
      barCodeSettings: Object,
    },

    computed: {
      priceStartIndex() {
        return parseInt(this.barCodeSettings.priceStartIndex) + 1;
      },
      priceEndIndex() {
        return parseInt(this.barCodeSettings.priceStartIndex) + (parseInt(this.barCodeSettings.priceLength));
      },
      maxPriceLength() {
        return Math.min(parseInt(this.barCodeSettings.totalLenght) - parseInt(this.barCodeSettings.priceStartIndex), parseInt(this.barCodeSettings.totalLenght));
      },
      maxPriceIndex() {
        return parseInt(this.barCodeSettings.totalLenght) - parseInt(this.barCodeSettings.priceLength) + 1;
      },
      priceLengthValidation() {
      return this.priceEndIndex >= this.priceStartIndex && this.priceStartIndex > 0;
      },
      indexes() {
        let indexes = [];
        for (let i = 0; i < this.barCodeSettings.totalLenght; i++) {
          indexes.push(i >= this.barCodeSettings.priceStartIndex && i < this.priceEndIndex && this.priceStartIndex > 0);
        }
        return indexes;
      }
    }
  }
</script>

<style lang="scss" scoped>

  .barcode-settings__price-setting {
    display: flex;
    flex-wrap: wrap;
  }

  .separator {
    border-top: 1px dashed #dbdbdb;
    padding: 20px 0 10px 0;
    margin-top: 10px;
  }

  .feature {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .feature-name {
    flex-grow: 1;
    font-weight: 500;
  }

  .price-setting__values {
    display: flex;
    margin-right: 40px;
    flex-basis: 0;
    flex-grow: 1;

    .price-setting__start-index, .price-setting__length {
      flex-grow: 1;
      flex-basis: 0;
    }

    .price-setting__start-index {
      margin-right: 20px;
    }
  }

  .price-setting__display {
    flex-basis: 0;
    flex-grow: 1;

    .barcode__code {
      display: flex;
      padding-top: 12px;
    }

    .digit {
      font-family: monospace;
      font-weight: bold;
      font-size: 20px;
      padding: 0 4px 2px 4px;
      line-height: 1;
      position: relative;
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;
      &.highlighted {
        background-color: #ecfff2;
        color: #24bf00;
        border-top: 1px solid #24bf00;
        border-bottom: 1px solid #24bf00;
      }
      &.start {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        &.highlighted {
          border-left: 1px solid;
        }
        &::after {
          content: "↑";
          position: absolute;
          top: 100%;
          left: 50%;
          padding-top: 4px;
          transform: translateX(-50%);
        }
      }
      &.end {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-right: 1px solid;
      }
    }
  }


</style>